#import "../fragments/sms-deliverability-fragment.graphql"
#import "../fragments/email-deliverability-fragment.graphql"

query GetContactDeliverabilityStatuses($contactId: ID!) {
    contact(id: $contactId) {
        id
        phones {
            primary {
                deliverabilityStatus {
                    ...SmsDeliverabilityFragment
                }
            }
        }
        emailAddresses {
            primary {
                deliverabilityStatus {
                    ...EmailDeliverabilityFragment
                }
            }
        }
    }
}
